import { render } from "./Agreement.vue?vue&type=template&id=5620350a"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Agreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5620350a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5620350a', __exports__)) {
    api.reload('5620350a', __exports__)
  }
  
  module.hot.accept("./Agreement.vue?vue&type=template&id=5620350a", () => {
    api.rerender('5620350a', render)
  })

}


export default __exports__